// extracted by mini-css-extract-plugin
export default {"card":"SongCardAdmin_card__dWPLU","image":"SongCardAdmin_image__xXD+Y"};